var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_1341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 9.99984C18.3327 13.9282 18.3327 15.8924 17.1123 17.1128C15.8919 18.3332 13.9277 18.3332 9.99935 18.3332C6.07098 18.3332 4.10679 18.3332 2.8864 17.1128C1.66602 15.8924 1.66602 13.9282 1.66602 9.99984C1.66602 6.07147 1.66602 4.10728 2.8864 2.88689C4.10679 1.6665 6.07098 1.6665 9.99935 1.6665",
    stroke: "#3F83F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 10.4165L3.12567 9.13927C3.88506 8.47481 5.02958 8.51292 5.74309 9.22642L9.31786 12.8012C9.89055 13.3739 10.7921 13.452 11.4547 12.9863L11.7032 12.8116C12.6567 12.1415 13.9468 12.2192 14.8131 12.9988L17.4993 15.4165",
    stroke: "#3F83F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.58317H15.4167M15.4167 4.58317H18.3333M15.4167 4.58317V7.49984M15.4167 4.58317V1.6665",
    stroke: "#3F83F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_1341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.cdde2e2e1cf6c83a29d80c7152667351.svg";
export { ForwardRef as ReactComponent };